import { useState } from 'react';
import LoginForm from '../../components/form/LoginForm';

const Login = () => {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <div className="d-flex flex-column min-vh-100 w-100 py-4 mx-auto" style={{ maxWidth: 416 }}>
		<LoginForm setErrorMessage={setErrorMessage} errorMessage={errorMessage} />
		<div className="d-flex align-items-center my-4">
		</div>
    </div>
  );
};

export default Login;
